import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import React from "react";
import AppRoutes from "./routes/route";
import { useTranslation } from "react-i18next";
import { LangContext } from "./context/context";
import { persistor} from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import {basename} from './config';

const queryClient = new QueryClient();

function App() {
  const { i18n } = useTranslation();
  let lang = i18n.language;
  
  
  return (
   <LangContext.Provider value={{lang}}>
      <QueryClientProvider client={queryClient}>
        <div className="">
          <Router>
            <React.Fragment>
            <PersistGate loading={null} persistor={persistor}>
              <AppRoutes />
              </PersistGate>
            </React.Fragment>
          </Router>
        </div>
      </QueryClientProvider>
      </LangContext.Provider>
  );
}

export default App;
